/*@flow*/

type FlashT = 'info' | 'danger' | 'success' | 'warning';

export default function flash(msg: string, type: FlashT = 'danger') {
  $('#FlashMessage').remove();
  const types = ['info', 'danger', 'success', 'warning'];
  if (!types.includes(type)) {
    throw new Error('[flash] Unknown type: `' + type + '`');
  }

  const tmpl = `<div id="FlashMessage" style="position: fixed; left: 0; right: 0; top: 0; z-index: 99999;">
    <div class="alert alert-${type}">
      ${msg}
    </div>
  </div>`;
  $(tmpl).insertBefore('article#site');

  $('#FlashMessage .close').on('click', function() {
    $('#FlashMessage').fadeOut(200);
  });

  setTimeout(() => $('#FlashMessage').fadeOut(200), 2400);
}
